import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import { interviewAvailabilityShape } from '../../../../dateUtils';
import { isMobile } from '../../../../screenUtils';
import PastInterviewCard from './Cards/PastInterviewCard';
import UpcomingInterviewCard from './Cards/UpcomingInterviewCard';
import PendingInterviewCard from './Cards/PendingInterviewCard';
import RescheduleInterviewCard from './Cards/RescheduleInterviewCard';
import './InterviewCardOverlay.scss';
var typeToRenderer = {
  upcoming: UpcomingInterviewCard,
  pending: PendingInterviewCard,
  past: PastInterviewCard,
  reschedule: RescheduleInterviewCard
};
var overlayCardShadow = '0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 9px 46px 8px rgba(0, 0, 0, 0.12), 0px 24px 38px 3px rgba(0, 0, 0, 0.1)';
var overlayStyles = function overlayStyles(style) {
  return isMobile() ? _objectSpread(_objectSpread({}, style), {}, {
    backgroundColor: '#FFF',
    width: '100%',
    borderRadius: '4px',
    boxShadow: overlayCardShadow,
    zIndex: 999
  }) : _objectSpread(_objectSpread({}, style), {}, {
    position: 'absolute',
    backgroundColor: '#FFF',
    top: 'auto',
    bottom: '0px',
    marginLeft: '7px',
    width: '400px',
    borderRadius: '4px',
    boxShadow: overlayCardShadow,
    zIndex: 999
  });
};
function InterviewCardOverlay(_ref) {
  var className = _ref.className,
    style = _ref.style,
    interviewType = _ref.interviewType,
    interview = _ref.interview,
    possibleInterviewers = _ref.possibleInterviewers,
    invitableRoles = _ref.invitableRoles,
    onCancel = _ref.onCancel,
    onSubmitMeetingDetails = _ref.onSubmitMeetingDetails,
    canCancel = _ref.canCancel,
    canEdit = _ref.canEdit,
    consultantView = _ref.consultantView,
    closeOverlay = _ref.closeOverlay,
    isRep = _ref.isRep,
    csrfToken = _ref.csrfToken,
    editModalRef = _ref.editModalRef,
    repOrOwner = _ref.repOrOwner,
    resheduleModalRef = _ref.resheduleModalRef,
    availableInterviewSlotUrl = _ref.availableInterviewSlotUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: overlayStyles(style)
  }, /*#__PURE__*/React.createElement("div", {
    className: "interview-card-header g-row--always g-row-justify-right",
    id: interviewType
  }, /*#__PURE__*/React.createElement("a", {
    className: "close-interview-card",
    onClick: closeOverlay,
    role: "button",
    tabIndex: "0"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-times"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "style-guide interview-card-overlay"
  }, typeToRenderer[interviewType]({
    interview: interview,
    possibleInterviewers: possibleInterviewers,
    invitableRoles: invitableRoles,
    csrfToken: csrfToken,
    editModalRef: editModalRef,
    onCancel: onCancel,
    onSubmitMeetingDetails: onSubmitMeetingDetails,
    isRep: isRep,
    canCancel: canCancel,
    canEdit: canEdit,
    consultantView: consultantView,
    repOrOwner: repOrOwner,
    closeOverlay: closeOverlay,
    resheduleModalRef: resheduleModalRef,
    interviewType: interviewType,
    availableInterviewSlotUrl: availableInterviewSlotUrl
  })));
}
InterviewCardOverlay.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
  interviewType: PropTypes.string.isRequired,
  interview: PropTypes.shape({
    accepted_time: interviewAvailabilityShape,
    attendees: PropTypes.shape({
      consultant: PropTypes.string,
      invitees: PropTypes.arrayOf(PropTypes.string),
      requester: PropTypes.string
    }).isRequired,
    availabilities: PropTypes.arrayOf(interviewAvailabilityShape),
    timezone: PropTypes.string.isRequired,
    round_number: PropTypes.number,
    id: PropTypes.number.isRequired,
    edit_interview_path: PropTypes.string,
    cancel_interview_path: PropTypes.string
  }).isRequired,
  possibleInterviewers: PropTypes.shape({}),
  invitableRoles: PropTypes.arrayOf(PropTypes.string),
  csrfToken: PropTypes.string.isRequired,
  editModalRef: PropTypes.func,
  resheduleModalRef: PropTypes.func,
  onCancel: PropTypes.func,
  onSubmitMeetingDetails: PropTypes.func,
  canEdit: PropTypes.bool,
  canCancel: PropTypes.bool,
  consultantView: PropTypes.bool,
  closeOverlay: PropTypes.func,
  isRep: PropTypes.bool,
  repOrOwner: PropTypes.bool,
  availableInterviewSlotUrl: PropTypes.string.isRequired
};
InterviewCardOverlay.defaultProps = {
  possibleInterviewers: [],
  invitableRoles: [],
  editModalRef: function editModalRef() {
    return null;
  },
  resheduleModalRef: function resheduleModalRef() {
    return null;
  },
  onCancel: function onCancel() {
    return null;
  },
  onSubmitMeetingDetails: function onSubmitMeetingDetails() {
    return null;
  },
  closeOverlay: function closeOverlay() {
    return null;
  },
  isRep: false,
  canEdit: false,
  canCancel: false,
  repOrOwner: false,
  consultantView: false,
  className: ''
};
export default InterviewCardOverlay;